import { type SelectOption } from '../../../../../components';
import {
  ApplicantPublicationRole,
  PublicationStatus,
  PublicationTypes,
} from './types';
import { PAGE_TEXT } from '../lang';

const pageText = PAGE_TEXT.OTHER_INFORMATION.PUBLICATION;
export const PublicationTypesOptions: SelectOption[] = [
  {
    value: PublicationTypes.JOURNAL_ARTICLE,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.JOURNAL_ARTICLE],
  },
  {
    value: PublicationTypes.CONFERENCE_PRESENTATION,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.CONFERENCE_PRESENTATION],
  },
  {
    value: PublicationTypes.CONFERENCE_PUBLICATION,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.CONFERENCE_PUBLICATION],
  },
  {
    value: PublicationTypes.BOOK_CHAPTER,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.BOOK_CHAPTER],
  },
  {
    value: PublicationTypes.PROFESSIONAL_MAGAZINE,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.PROFESSIONAL_MAGAZINE],
  },
  {
    value: PublicationTypes.NEWSPAPER,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.NEWSPAPER],
  },
  {
    value: PublicationTypes.EXHIBITION,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.EXHIBITION],
  },
  {
    value: PublicationTypes.PATENTS,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.PATENTS],
  },
  {
    value: PublicationTypes.OTHER_PUBLICATION,
    label: pageText.PUBLICATION_TYPES[PublicationTypes.OTHER_PUBLICATION],
  },
];

export const ApplicantRoleOptions: SelectOption[] = [
  {
    value: ApplicantPublicationRole.FIRST_AUTHOR,
    label: pageText.PUBLICATION_ROLES[ApplicantPublicationRole.FIRST_AUTHOR],
  },
  {
    value: ApplicantPublicationRole.SECOND_AUTHOR,
    label: pageText.PUBLICATION_ROLES[ApplicantPublicationRole.SECOND_AUTHOR],
  },
  {
    value: ApplicantPublicationRole.CORRESPONDING_AUTHOR,
    label:
      pageText.PUBLICATION_ROLES[ApplicantPublicationRole.CORRESPONDING_AUTHOR],
  },
  {
    value: ApplicantPublicationRole.OTHER,
    label: pageText.PUBLICATION_ROLES[ApplicantPublicationRole.OTHER],
  },
];

export const PublicationStatusOptions: SelectOption[] = [
  {
    value: PublicationStatus.PUBLISHED,
    label: pageText.PUBLICATION_STATUSES[PublicationStatus.PUBLISHED],
  },
  {
    value: PublicationStatus.IN_PRESS,
    label: pageText.PUBLICATION_STATUSES[PublicationStatus.IN_PRESS],
  },
  {
    value: PublicationStatus.UNDER_REVIEW,
    label: pageText.PUBLICATION_STATUSES[PublicationStatus.UNDER_REVIEW],
  },
  {
    value: PublicationStatus.WRITING_IN_PROGRESS,
    label: pageText.PUBLICATION_STATUSES[PublicationStatus.WRITING_IN_PROGRESS],
  },
];

export const isNotPaper: string[] = [
  PublicationTypes.EXHIBITION,
  PublicationTypes.OTHER_PUBLICATION,
];
